import { Box, Button, Container, Paper, Stack, Text, Title } from "@mantine/core";
import { useCallback } from "react";

type Pagina2Properties = {
  onSelecionarCategoria: (categoria: string) => void;
  categoriasDisponiveis: string[];
  onConfirmarVotos: () => void;
  votos: { categoria: string; empresa: string }[];
};

const Pagina2 = ({ onSelecionarCategoria, categoriasDisponiveis, onConfirmarVotos, votos }: Pagina2Properties) => {
  const handleClick = useCallback(
    (categoria: string) => () => {
      onSelecionarCategoria(categoria);
    },
    [onSelecionarCategoria]
  );

  return (
    <Container size="sm" py="xl">
      <Stack align="center" ta="center">
        <Title order={1} size="1.5rem" fw={700} c="gray.8" mb="xs" style={{ lineHeight: 1.2 }}>
          A empresa a qual você deseja votar pertence à qual categoria?
        </Title>

        <Text size="md">
          Sabemos que você está ansioso para registrar seu voto em sua empresa favorita! Mas calma, primeiro nos informe
          a qual categoria ela pertence:
        </Text>

        <Box w="100%" mt="lg">
          <Stack>
            {categoriasDisponiveis.map((categoria) => (
              <Paper
                key={categoria}
                shadow="sm"
                p="md"
                withBorder
                style={{ cursor: "pointer" }}
                onClick={handleClick(categoria)}
              >
                <Text size="lg" w="100%" ta={"center"}>
                  {categoria}
                </Text>
              </Paper>
            ))}
          </Stack>
        </Box>
        {votos.length > 0 && (
          <Button onClick={onConfirmarVotos} mt="lg">
            Confirma Votos & Finalizar
          </Button>
        )}
      </Stack>
    </Container>
  );
};

export default Pagina2;
